import { Observable, map } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { tenantCommand } from '../../model/const/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { RepayBalanceFormComponent } from '../../component/repay-balance-form/repay-balance-form.component';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class RepayBalanceCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _navigation: NavigationService,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === tenantCommand.repayBalance && command.context;
    }
    return false;
  }
  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._actionService.open(RepayBalanceFormComponent, this._injector, null, command.context).pipe(
        map(res => {
          this._navigation.reloadCurrentRoute();
        })
      );
    }
  }
}
